interface AboutProps {
  location: string;
}

export function About({ location }: AboutProps) {
  const facts = [
    { label: "Experience", value: "12 years" },
    { label: "Practice", value: "Solo" },
    { label: "Status", value: "Fully committed" },
  ];

  return (
    <section
      id="about"
      style={{
        position: "relative",
        padding: "var(--section-y, 120px) 32px",
        background: "color-mix(in oklab, var(--paper-soft) 82%, transparent)",
        backdropFilter: "blur(6px)",
        borderTop: "1px solid var(--hairline)",
        borderBottom: "1px solid var(--hairline)",
      }}
    >
      <div className="container">
        <div style={{ maxWidth: 720 }}>

          <div style={{ display: "flex", flexDirection: "column", gap: 24 }}>
            <span className="rule-eyebrow">About</span>
            <h2
              style={{
                margin: 0,
                fontFamily: "var(--font-display)",
                fontWeight: 300,
                fontSize: "clamp(36px, 4.4vw, 52px)",
                lineHeight: 1.04,
                letterSpacing: "-0.02em",
                color: "var(--ink)",
              }}
            >
              Twelve years of classical engineering, now sharpened by agentic AI.
            </h2>
            <div style={{ display: "flex", flexDirection: "column", gap: 16, maxWidth: 560 }}>
              <p style={{ margin: 0, fontFamily: "var(--font-body)", fontSize: 16, lineHeight: 1.65, color: "var(--ink-2)" }}>
                I'm a senior software engineer based in {location}. I've spent twelve years shipping classical full-stack systems — the unglamorous foundations that real products are built on — and the last two embedded in applied AI, building agentic systems for production, not demos.
              </p>
              <p style={{ margin: 0, fontFamily: "var(--font-body)", fontSize: 16, lineHeight: 1.65, color: "var(--ink-2)" }}>
                Slimsoft is my solo practice. I take on a small number of focused engagements at a time — forward-deployed inside founding teams, or alongside engineering leaders adopting AI properly for the first time. I also do Ubiquiti-grade IT and self-hosted smart-home builds for studios and homes that want serious infra without the enterprise tax.
              </p>
              <p style={{ margin: 0, fontFamily: "var(--font-body)", fontSize: 16, lineHeight: 1.65, color: "var(--ink-2)" }}>
                I'm currently fully committed — but I read every reachout, and I'd rather hear about your project early than not at all.
              </p>
            </div>

            <div
              className="fact-strip"
              style={{
                marginTop: 12,
                display: "grid",
                gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                gap: 0,
                borderTop: "1px solid var(--hairline)",
                paddingTop: 24,
              }}
            >
              {facts.map((fact) => (
                <div key={fact.label} style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                  <span
                    style={{
                      fontFamily: "var(--font-mono)",
                      fontSize: 10,
                      letterSpacing: "0.16em",
                      textTransform: "uppercase",
                      color: "var(--ink-4)",
                    }}
                  >
                    {fact.label}
                  </span>
                  <span style={{ fontFamily: "var(--font-display)", fontWeight: 500, fontSize: 16, color: "var(--ink)" }}>
                    {fact.value}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
